import {useCallback} from 'react';
import {isObjectEmpty} from '@stencil/hotels-utils/src/common-utils';
import useNavigator from './useNavigator';

interface CommonStreaksInfo {
  in_progress: boolean;
  is_gostreaks_active: boolean;
  go_streaks_web_url: string;
  go_stays_web_url: string;
  thank_you?: {
    show_tracker: boolean;
  };
}

export const PAGE_NAMES = {
  thankyou: 'ThankYou',
};

const useGoStreaksClick = (streaksInfo: CommonStreaksInfo, isDweb = false, pageName = '') => {
  const [navigateTo] = useNavigator();

  const isGoStreaksData = !!streaksInfo && !isObjectEmpty(streaksInfo);

  const onGoStreaksClickCta = useCallback(() => {
    if (!isGoStreaksData) {
      return null;
    }

    /* @Note for thank you page only, the preference is given more to show_tracker for my earning */
    if (
      streaksInfo?.in_progress ||
      (pageName === PAGE_NAMES.thankyou &&
        streaksInfo?.thank_you &&
        streaksInfo?.thank_you?.show_tracker)
    ) {
      navigateTo({target: 'myearning'});
    } else {
      if (streaksInfo?.is_gostreaks_active) {
        navigateTo({target: 'newurl', url: streaksInfo?.go_streaks_web_url, openInNewTab: isDweb});
      } else {
        navigateTo({
          target: 'newurl',
          url: streaksInfo?.go_stays_web_url || 'https://www.goibibo.com/offers/gostays-learnmore/',
          openInNewTab: isDweb,
        });
      }
    }
  }, [streaksInfo?.in_progress, streaksInfo?.is_gostreaks_active]);

  /*  @Note Note that the React team recommends that custom 
        hooks that return more than two values should use proper 
        objects instead of tuples, however. */
  return [onGoStreaksClickCta, isGoStreaksData] as const;
};

export default useGoStreaksClick;
